import { useSearchParams } from 'react-router-dom'
import { compact, startCase } from 'lodash'
import { useEffect, useState } from 'react'
import { observer } from 'mobx-react-lite'
import { ActivitiesPageComponent } from 'app/components/activities-page/ActivitiesPageComponent'
import { useActivitiesPage } from 'app/components/activities-page/useActivitiesPage'
import {
  FilterObject,
  PredefinedFilter,
  convertFilterToESQueryString,
  convertUrlFiltersToES,
  encodeFilters,
} from 'app/filter.utils'
import { comActivityTypes } from 'lib/comActivityTypes'
import { logError } from 'lib/logging'
import { tagsPages } from 'lib/recordTypes'

export default observer(function ActivitiesView() {
  const hookData = useActivitiesPage()
  return <ActivitiesPageComponent {...hookData} />
})
